// src/features/agent-builder/components/AIToolsmithTeaser.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextareaField, Button, Tooltip } from '@dopomogai/ui'; // Assuming TextareaField is exported from ui
import { renderIcon } from '@dopomogai/utils';

interface AIToolsmithTeaserProps {
  description: string;
  onDescriptionChange: (value: string) => void;
  // onGenerateCode: () => void; // This would be the action if it were active
}

export const AIToolsmithTeaser: React.FC<AIToolsmithTeaserProps> = ({
  description,
  onDescriptionChange,
  // onGenerateCode,
}) => {
  const { t } = useTranslation('agentBuilder');

  return (
    <div className="space-y-4 py-4">
      <TextareaField
        labelKey="agentBuilder:skillModal.aiToolsmith.describeLabel"
        placeholder={t('skillModal.aiToolsmith.describePlaceholder')} // Corrected: use placeholder and t()
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        rows={6}
        // Assuming TextareaField has containerClassName like TextField for outer styling
        containerClassName="opacity-80" 
        // Or if it applies to the textarea itself:
        // textareaClassName="opacity-80" 
        // Or if it takes className for the root element of TextareaField:
        // className="opacity-80"
      />
      <div className="flex justify-end">
        <Tooltip
          textKey="agentBuilder:skillModal.aiToolsmith.generateTooltip"
        >
          <Button
            textKey="agentBuilder:skillModal.aiToolsmith.generateButton"
            variant="primary"
            disabled // Always disabled for the teaser
            // onClick={onGenerateCode}
            icon={renderIcon('sparkles', { size: 16 })}
            className="opacity-70 cursor-not-allowed"
          />
        </Tooltip>
      </div>
      <p className="text-xs text-center text-slate-500 pt-2">
        {t('skillModal.aiToolsmith.note')}
      </p>
    </div>
  );
};